import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type UpdateClusterResponse = ClientInferResponseBody<typeof contract.cluster.update>;

export const updateCluster = async ({
  sourceId,
  cluster,
}: {
  sourceId: string;
  cluster: string[];
}): Promise<UpdateClusterResponse | null> => {
  const response = await api.cluster.update.mutation({
    body: { cluster },
    params: {
      id: sourceId,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
